var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.attributeValue.description!=='' && _vm.attributeValue.description!==null) || 
           (_vm.attributeValue.url!=='' && _vm.attributeValue.url!==null))?_c('div',[_c('tooltip',{attrs:{"description":_vm.attributeValue.description}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }